import { FieldHistoryPanel } from './field-history-panel';

type Props = {
    routeStopId?: number;
    attractionId?: number;
};

// Field history already includes legacy staff notes.
export const StaffNotesPanel = ({ routeStopId, attractionId }: Props) => {
    if (!routeStopId && !attractionId) return null;
    return (
        <FieldHistoryPanel
            title="История этой точки"
            target={{
                kind: routeStopId ? 'stop' : 'attraction',
                id: routeStopId || attractionId!,
            }}
        />
    );
};
